module.exports = __webpack_public_path__ + "media/assets/images/personas/claudio_schema-e36eca0919f796959f1384710fef52cb.png";